import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { TeamPaymentCollectionsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createTeamPaymentCollection = (data): any => action(types.CREATE_TEAM_PAYMENT_COLLECTION_REQUESTED, data);

export const updateTeamPaymentCollection = (
  data,
  callbackFunction = undefined,
): any => action(types.UPDATE_TEAM_PAYMENT_COLLECTION_REQUESTED, {
  data,
  callbackFunction,
});

export const deleteTeamPaymentCollection = (teamPaymentCollectionId): any => action(types.UPDATE_TEAM_PAYMENT_COLLECTION_REQUESTED, teamPaymentCollectionId);

export const getTeamPaymentCollection = (teamPaymentCollectionId): any => action(types.GET_TEAM_PAYMENT_COLLECTION_REQUESTED, teamPaymentCollectionId);

export const getAllTeamPaymentCollections = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_TEAM_PAYMENT_COLLECTIONS_REQUESTED, { pagination, compile });

export const getAllTeamPaymentCollectionsTeamMemberView = (
  pagination: IPagination = undefined,
  compile = true,
  teamCode = undefined,
  teamMemberCode = undefined,
): any => action(types.GET_ALL_TEAM_PAYMENT_COLLECTIONS_REQUESTED, {
  pagination, compile, teamMemberView: true, teamCode, teamMemberCode,
});

export const selectTeamPaymentCollection = (teamPaymentCollectionId): any => action(types.SELECT_TEAM_PAYMENT_COLLECTION_REQUESTED, {
  currentTeamPaymentCollectionId: teamPaymentCollectionId,
});

export const clearTeamPaymentCollections = (): any => action(types.CLEAR_TEAM_PAYMENT_COLLECTIONS);

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createTeamPaymentCollectionPending: (payload): any => action(types.CREATE_TEAM_PAYMENT_COLLECTION_PENDING, payload),
  createTeamPaymentCollectionSuccess: (response): any => action(types.CREATE_TEAM_PAYMENT_COLLECTION_SUCCESS, {
    teamPaymentCollectionsById: response.entities.teamPaymentCollections,
    currentTeamPaymentCollectionId: response.result,
  }),
  updateTeamPaymentCollectionPending: (payload): any => action(types.UPDATE_TEAM_PAYMENT_COLLECTION_PENDING, payload),
  updateTeamPaymentCollectionSuccess: (response): any => action(types.UPDATE_TEAM_PAYMENT_COLLECTION_SUCCESS, {
    teamPaymentCollectionsById: response.entities.teamPaymentCollections,
    currentTeamPaymentCollectionId: response.result,
  }),
  updateTeamPaymentCollectionFailed: (error): any => action(types.UPDATE_TEAM_PAYMENT_COLLECTION_FAIL, { backendErrors: error }),
  deleteTeamPaymentCollectionPending: (): any => action(types.UPDATE_TEAM_PAYMENT_COLLECTION_PENDING, {}),
  deleteTeamPaymentCollectionSuccess: (response, userId): any => {
    localStorage.set(userId, { currentTeamPaymentCollectionId: null });
    // history.push('/teamPaymentCollections');

    return action(types.DELETE_TEAM_PAYMENT_COLLECTION_SUCCESS, {
      currentTeamPaymentCollectionId: response,
    });
  },
  getTeamPaymentCollectionPending: (): any => action(types.GET_TEAM_PAYMENT_COLLECTION_PENDING, {}),
  getTeamPaymentCollectionSuccess: (response): any => action(types.GET_TEAM_PAYMENT_COLLECTION_SUCCESS, {
    teamPaymentCollectionsById: response.entities.teamPaymentCollections,
    currentTeamPaymentCollectionId: response.result,
  }),
  getTeamPaymentCollectionFailed: (error): any => action(types.GET_TEAM_PAYMENT_COLLECTION_FAIL, { backendErrors: error }),
  deleteTeamPaymentCollectionFailed: (error): any => action(types.UPDATE_TEAM_PAYMENT_COLLECTION_FAIL, { backendErrors: error }),
  getAllTeamPaymentCollectionsPending: (pagination): any => action(types.GET_ALL_TEAM_PAYMENT_COLLECTIONS_PENDING, { pagination }),
  getAllTeamPaymentCollectionsSuccess: (response, meta): any => action(types.GET_ALL_TEAM_PAYMENT_COLLECTIONS_SUCCESS, {
    teamPaymentCollectionsById: response.entities.teamPaymentCollections,
    teamPaymentCollectionIds: response.result,
    meta,
  }),
  getAllTeamPaymentCollectionsFailed: (error): any => action(types.GET_ALL_TEAM_PAYMENT_COLLECTIONS_FAIL, { backendErrors: error }),
  createTeamPaymentCollectionFailed: (error): any => action(types.CREATE_TEAM_PAYMENT_COLLECTION_FAIL, { backendErrors: error }),
};

export default {
  createTeamPaymentCollection,
  updateTeamPaymentCollection,
  deleteTeamPaymentCollection,
  getTeamPaymentCollection,
  getAllTeamPaymentCollections,
  getAllTeamPaymentCollectionsTeamMemberView,
  selectTeamPaymentCollection,
};
